var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckFilled = function SvgCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m2.428-6.51-2.75 2.75a.513.513 0 0 1-.729 0L3.074 5.865a.515.515 0 0 1 .728-.728l1.01 1.01L7.198 3.76a.515.515 0 0 1 .728.728z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11v11H0z"
  })))));
};
export default SvgCheckFilled;